import jwt from "jsonwebtoken";
import { USER_ADMIN } from "../constantsFormularis";
import { LOCAL_STORAGE_USER } from "../constantsObservacions";
import * as rutes from "../routes";
import { createBrowserHistory } from "history";

export const recuperarUsuari = usuari => {
  if (!calFerLogin(usuari)) {
    return usuari;
  } else {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    if (token) {
      return token;
    } else return {};
  }
};

export const isObservadorAdmin = usuari => {
  return usuari && usuari.idRol && usuari.idRol === USER_ADMIN;
};

export const esPaginaPublica = () => {
  const customHistory = createBrowserHistory();
  return customHistory.location.pathname === "/Accessibilitat";
};

export const navToPaginaPublica = () => {
  const customHistory = createBrowserHistory();
  if (customHistory.location.pathname === "/Accessibilitat") {
    return rutes.rutaAccessibilitat;
  }
};

export const calFerLogin = usuari => {
  return !usuari || !usuari.idObservador;
};

export const errorCercaToken = () => {
  return null;
};

export const senseRols = usuari => {
  return !usuari || !usuari.idRol;
};

export const tokenDecoded = token => {
  return jwt.decode(token, {
    complete: true
  }).payload;
};

export const getIdObservadorToken = () => {
  const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
  if (!token) return null;
  return tokenDecoded(token.token).idObservador;
};
